import { Button, InlineLoading, TextInput } from "@carbon/react";
import { useDispatch, useSelector } from 'react-redux'
import { tokenRequestThunk } from "../../features/user/userThunks"
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"
import { pushNotification } from "../../features/application/applicationSlice";
import { selectUser, selectAuthLoading, selectUserError } from "../../features/user/userSlice";
import { NotificationModel } from "../../models/Notification";
import { checkToken } from "../../apiClient/apiClient";
import { ArrowRight } from "@carbon/icons-react";
import { 
    checkError, 
    doLoginKey, 
    getErrorState,
    validateLogin,
    handleLoginInputs
} from './utils';
import { useTranslation } from "react-i18next";


const Index = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const user = useSelector(selectUser)
    const authLoading = useSelector(selectAuthLoading)
    const userError = useSelector(selectUserError)
    
    const navigate = useNavigate()
    const location = useLocation()
    const inputRef = useRef()

    const [invalid_dictionary, setinvalidDictionary] = useState({
        'invalid_username': false,
        'invalid_password': false,
        invalidText_username: '',
        invalidText_password: '',
        disabled: true
    });
    const [loginForm, setData] = useState({ username: "", password: "" })
    
    useEffect(() => {
        if (location.pathname === '/login' && checkToken(user.token_refresh)) {
            navigate("/dashboard")
        }
    }, [location.pathname, user.token_refresh, navigate])
    
    return (
        <div className="page-container login-screen">
            <div className="background-image-container"></div>
            <div className="login-panel">
                <div className="generic-element-panel login-container">
                    <div className="generic-form">
                        <div className="generic-form__header">
                            <h1>{t("auth.title")}</h1>
                            <p>
                            {t("auth.noAccount")} {" "}
                            <a href="mailto:support@possible.com" className="pointer">
                                {t("auth.contactUs")}
                            </a>
                            </p>
                        </div>

                        <TextInput
                            id="login-username-field"
                            className="generic-form__field"
                            invalid={invalid_dictionary.invalid_username}
                            invalidText={invalid_dictionary.invalidText_username}
                            labelText={t("auth.username")}
                            placeholder={t("auth.username")}
                            value={loginForm.username}
                            name="username"
                            onChange={(e) => checkInputs(e)}
                            autoFocus
                            ref={inputRef}
                        />
                        <TextInput
                            id="login-password-field"
                            className="generic-form__field"
                            invalid={invalid_dictionary.invalid_password}
                            invalidText={invalid_dictionary.invalidText_password}
                            labelText={t("auth.password")}
                            placeholder="******"
                            type="password"
                            name="password"
                            value={loginForm.password}
                            onChange={(e) => checkInputs(e)}
                            onKeyDown={(e) => doLoginKey(e, doLogin)}
                        />
                        {!authLoading &&
                            <Button
                                className="login-form-elm"
                                kind="primary"
                                renderIcon={ArrowRight}
                                onClick={doLogin}>
                                {t("auth.submit")}
                            </Button>
                        }
                        {authLoading &&
                            <InlineLoading
                                status='active'
                                iconDescription={t("common.loading")}
                                description={t("auth.submitting")}
                            />
                        }
                        {userError && <p className="error">{checkError(userError)}</p>}
                    </div>
                </div>
            </div>
        </div>
    )


    async function doLogin() {
        validate();
        if (!loginForm.username || !loginForm.password) return;

        try {
            await dispatch(tokenRequestThunk(loginForm)).unwrap();
            navigate('/dashboard');
        } catch (err) {
            const httpCode = err?.http_status_code ?? 0;
            const newState = getErrorState(httpCode, t);

            if (!String(httpCode).startsWith('4')) {
                dispatch(
                    pushNotification(
                        new NotificationModel(
                            t("auth.errorTitle"),
                            t("auth.errorBody", { status: httpCode || t("common.unknown") }),
                            'error'
                        ).toJson()
                    )
                );
            }

            setinvalidDictionary((prev) => ({ ...prev, ...newState }));
            inputRef.current?.focus();
        }
    }

    function validate() {
        setinvalidDictionary(validateLogin(loginForm, invalid_dictionary, t));
    }

    function checkInputs(e) {
        const { formData, validationState } = handleLoginInputs(e, loginForm, invalid_dictionary, t);
        setData(formData);
        setinvalidDictionary(validationState);
    }
}

export default Index
